export function getAccessToken() {
  return  localStorage.getItem("token") !== undefined && localStorage.getItem("token")
    ? JSON.parse(localStorage.getItem("token"))
    : undefined;
}
export function refreshToken(newToken) {
  localStorage.setItem("token", JSON.stringify(newToken));
}
